import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, Paper, Typography, Divider, IconButton, InputAdornment, Link, Box,
} from '@material-ui/core';
import { VisibilityOff, Visibility } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field } from 'redux-form';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Moment from 'moment';
import { styles } from '../../../styles';
import { text } from "../../meCommon";
import * as actions from '../../../../store/actions/index';
import AlertDialog from '../../../common/AlertDialog';

Moment.locale('en');
const validate = values => {
    const errors = {};
    const required = [];
    required.forEach((field, index) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};

const pwdRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");

class ResetPassword extends Component {

    constructor(props){
        super(props);
        this.state = {
            password : '', confirmPassword : '', token: '',
            error: { password: '', confirmPassword: '', token: '' },
            showReset: false, enableVerifyCode: true, showAlert: false,
            isPwdLength: true, isOneUpperLetter: true, isOneLowerLetter: true, isOneNumber: true, isOneSpecial: true,
            show: { password: false, confirmPassword: false },
        }
    }

    handleChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value}, () => {
        switch(name){
            case "password":
                if (value.length < 8) {
                    this.setState({ isPwdLength: true});
                } else {
                    this.setState({ isPwdLength: false});
                }
                if (value.search(/[a-z]/) === -1) {
                    this.setState({ isOneLowerLetter: true});
                } else {
                    this.setState({ isOneLowerLetter: false});
                }
                if (value.search(/[A-Z]/) === -1) {
                    this.setState({ isOneUpperLetter: true});
                } else {
                    this.setState({ isOneUpperLetter: false});
                }
                if (value.search(/[0-9]/) === -1) {
                    this.setState({ isOneNumber: true});
                } else {
                    this.setState({ isOneNumber: false});
                }
                if (value.search(/[!@#$%^&*]/) === -1) {
                    this.setState({ isOneSpecial: true});
                } else {
                    this.setState({ isOneSpecial: false});
                }
                if (pwdRegex.test(value)) {
                    this.setState({ error: {...this.state.error, password: ''}});
                } else {
                    this.setState({ error: {...this.state.error, password: 'Please use the below in your password:'}});
                }
                if(this.state.confirmPassword !== "" && (this.state.password !== this.state.confirmPassword)) {
                    this.setState({ error: {...this.state.error, confirmPassword: 'Confirm password should match password'}});
                } else {
                    this.setState({ error: {...this.state.error, confirmPassword: ''}});
                }
                break;
            case "confirmPassword":
                if (this.state.password === this.state.confirmPassword) {
                    this.setState({ error: {...this.state.error, confirmPassword: ''}});
                } else {
                    this.setState({ error: {...this.state.error, confirmPassword: 'Confirm password should match password'}});
                }
                break;
            case "token":
                if (this.state.token.length > 4) {
                    this.setState({ enableVerifyCode: false });
                } else {
                    this.setState({ enableVerifyCode: true });
                }
                break;
            default: 
        }    
        });
    };

    handleShow = (name) => {
        const { password, confirmPassword } = this.state.show;
        switch(name) {
            case 'password':
                this.setState({ show: {...this.state.show, password: !password }});
                break;
            case 'confirmPassword':
                this.setState({ show: {...this.state.show, confirmPassword: !confirmPassword }});
                break;
            default:
                //
        }
    }
    onPasswordChange = () => {
        const { userInfo } = this.props;
        if(userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            params.password = this.state.password;
            this.props.dispatch(actions.changePassword(params, () => {
                this.setState({ showAlert: true });
                }));
        }
    }
    onVerifyCode = () => {
        const { userInfo } = this.props;
        if(userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            params.requestToken = this.state.token;
            this.props.dispatch(actions.verifyToken(params, () => {
                this.setState({ showReset: true });
                }));
        }
    }
    resendVerificationCode = () => {
        const { userInfo } = this.props;
        if(userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            this.props.dispatch(actions.forgetPassword(params, () => {
                // this.props.history.push('/resetPassword');
            }));
        }
    }

        

    renderTextField = (props) => {
        const {input, meta, label, isIcon, type, handleShow, error, required, multiline, ...custom} = props;
        return (
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={(required && meta.touched && meta.pristine) || error}
                helperText={required && meta.touched && ((meta.pristine && <span className="text-danger">{label} is Required</span>)
                || (error && <span className="text-danger">{error}</span>)
                || (meta.warning && <span>{meta.warning}</span>))}
                margin="normal"
                variant="outlined" 
                fullWidth={true}             
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
                required={required}
                type={ type ? type : 'text' }  
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                        {isIcon && 
                        <IconButton onClick={handleShow}>
                            {type === 'text' ? 
                            <Visibility /> : 
                            <VisibilityOff />
                            }
                        </IconButton>
                        }
                        </InputAdornment>
                    ),
                  }}
            />
        );
    }    

    renderField = (name, label, value, required, error, password, isIcon, handleShow) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required}
                error={error} type={password} onChange={this.handleChange} isIcon={isIcon} handleShow={handleShow}
            />
        )
    }
    renderButton = (label, handler, disabled, variant, color) => {
        return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} style={{ margin: '0 10px 0 5px', paddingLeft: '20px', paddingRight: '20px'}} disabled={disabled}>
                {label}
                <span style={{ padding: '0 10px' }}>
                    {label === "Reset Password" && this.props.loading && (
                        <CircularProgress size={16} thickness={2} color='inherit' />
                    )}
                </span>
            </Button>
        );
    }

    renderProgress = () => {
        const { loading } = this.props;
        if (loading) {
            return (
                <CircularProgress
                    size={70}
                    color={"secondary"}
                    style={{position: 'absolute', jusitfyContent: 'center', top: 0, left: 0, bottom: 0, right: 0, margin: 'auto'}}
                />
            );
        } else {
            return null;
        }
    }
    enableResetPassword = () => {
        const { password, confirmPassword, error} = this.state;
        if(password && confirmPassword && !error.password && !error.confirmPassword && !this.props.loading) {
            return false;
        }
        return true;
    }
    formActions = () => {
        const { handleSubmit, loading } = this.props;
        return(
            <Grid item key={19} xs={12} sm={12} md={12} lg={12} style={{ padding: "40px 20px 0" }}>
                <Grid container spacing={1} alignItems='center' justify='left'>             
                    {this.renderButton('Reset Password', handleSubmit(this.onPasswordChange), this.enableResetPassword())}
                    {this.renderButton('Cancel', ()=>{ this.props.history.push('/login'); }, loading, "text", "secondary")}
                </Grid>
            </Grid>
        )
    }
    renderChangePassword = () => {
        // const { handleSubmit, loading } = this.props;
        const { isPwdLength, isOneLowerLetter, isOneUpperLetter, isOneNumber, isOneSpecial, password, confirmPassword, show} = this.state;
        return(
            <Grid container spacing={1}>
                <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary">Reset Password</Typography>
                    <Divider variant="fullWidth"/>
                </Grid>
                <Grid item key={2} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {/* {this.renderField('password', 'Password', password, true, this.state.error.password, "password")} */}
                    {this.renderField('password', 'Password', password, true, this.state.error.password, show.password ? "text" : "password", true, () => this.handleShow('password'))}
                    {isPwdLength && text("body2", "Minimum 8 characters", { color: "#49afde"})}
                    {isOneUpperLetter && text("body2", "One uppercase letter", { color: "#49afde"})}
                    {isOneLowerLetter && text("body2", "One lowercase letter", { color: "#49afde"})}
                    {isOneNumber && text("body2", "One number", { color: "#49afde"})}
                    {isOneSpecial && text("body2", "One special character(Ex: !, @, #, $, %, ^, &, *)", { color: "#49afde"})}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                <Grid item key={4} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                {this.renderField('confirmPassword', 'Confirm Password', confirmPassword, true, this.state.error.confirmPassword, show.confirmPassword ? "text" : "password", true, () => this.handleShow('confirmPassword'))}
                </Grid>
                <Grid item key={5} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                { this.formActions()}
                <Grid item key={37} xs={12} sm={2} md={3} lg={4}>{this.renderProgress()}</Grid>
            </Grid>
        )
    }
    checkToken = () => {
        const { handleSubmit, loading } = this.props;
        return(
            <Grid container spacing={1}>
                <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary">Enter verification code </Typography>
                    <Divider variant="fullWidth"/>
                </Grid>
                <Grid item key={2} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}>
                    {this.renderField('token', 'Verification Code', this.state.token, true)}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6} style={{ padding: "0 20px" }}></Grid>
                <Grid item key={4} xs={12} sm={12} md={12} lg={12} style={{ padding: "40px 20px 0" }}>
                <Grid container spacing={1} alignItems='center' justify='left'>             
                    {this.renderButton('Verify Code', handleSubmit(this.onVerifyCode), this.state.enableVerifyCode)}
                    {this.renderButton('Cancel', ()=>{ this.props.history.push('/login'); }, loading, "text", "secondary")}
                </Grid>
                <Grid item key={6} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                    <Typography variant="caption"  component={'span'} >Still waiting for your verification code? 
                            <Box fontWeight="fontWeightRegular" display="inline">
                                <Link href="#" onClick={this.resendVerificationCode}> Resend verification code</Link>
                            </Box> 
                    </Typography>
                </Grid>
            </Grid>
                <Grid item key={37} xs={12} sm={2} md={3} lg={4}>{this.renderProgress()}</Grid>
            </Grid>
        )
    }
    closeAlert = () => { 
        this.setState({ showAlert: false });
        this.props.history.push('/login');
    }
    render() {
        const { classes } = this.props;
        return(
            <Grid container spacing={1} alignItems='center' justify='center'>
                <Paper className={classes.paperForm} elevation={2} style={{ width: "60%", margin: "20px"}}>
                    {!this.state.showReset && this.checkToken()}
                    {this.state.showReset && this.renderChangePassword()}
                </Paper>
                {this.state.showAlert && <AlertDialog open={true} message="Password reset is successful" close={() => this.closeAlert()} />}
            </Grid>
        )
    }
}

ResetPassword.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        userInfo: state.members && state.members.userInfo
        }
};

ResetPassword = reduxForm({ 
    form: 'resetPasswordForm' ,
    enableReinitialize: true,
    validate,
    fields: [
        'email'
    ]
})(ResetPassword);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(ResetPassword); 